var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002972"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1855",
    width: 16,
    height: 16,
    rx: 4,
    fill: "#3582D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7013 3.34015C12.5598 3.17026 12.3069 3.14908 12.1451 3.30831C11.5181 3.88167 10.9416 4.48682 10.3651 5.11321C9.7988 5.73968 9.24254 6.37668 8.70653 7.03493C7.91768 8.02229 7.15917 9.0522 6.45123 10.1139L3.88241 7.21542C3.76107 7.07737 3.55882 7.03494 3.39699 7.14106C3.20481 7.25786 3.14415 7.5127 3.2554 7.71435C3.2554 7.71435 5.70286 12.1417 5.80399 12.3328C5.90515 12.5133 6.12766 12.8 6.58274 12.8C7.02775 12.8 7.27042 12.524 7.41208 12.2373C7.56376 11.94 8.919 9.30695 9.79886 7.9161C10.2337 7.21534 10.709 6.53584 11.1844 5.86698C11.6698 5.19808 12.1755 4.53983 12.6913 3.92403L12.7014 3.91344C12.8328 3.73296 12.8328 3.49937 12.7013 3.34007L12.7013 3.34015Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox-icon.9db43406105480ed0036489e0ebfa712.svg";
export { ForwardRef as ReactComponent };